// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/backJp.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/font/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/font/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/font/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/font/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/font/Poppins-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/font/Poppins-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/font/Muli-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/font/Muli-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/public/font/Muli-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/public/font/Muli-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.2 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.bottom-0 {
  bottom: 0px;
}
.left-2 {
  left: 0.5rem;
}
.right-0 {
  right: 0px;
}
.top-0 {
  top: 0px;
}
.top-2 {
  top: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.float-right {
  float: right;
}
.float-left {
  float: left;
}
.clear-both {
  clear: both;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-\\[10px\\] {
  margin-top: 10px;
  margin-bottom: 10px;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-\\[-2px\\] {
  margin-bottom: -2px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-\\[103px\\] {
  margin-left: 103px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-9 {
  margin-top: 2.25rem;
}
.mt-\\[-6px\\] {
  margin-top: -6px;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-20 {
  height: 5rem;
}
.h-28 {
  height: 7rem;
}
.h-5 {
  height: 1.25rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[55px\\] {
  height: 55px;
}
.h-\\[64px\\] {
  height: 64px;
}
.h-\\[67px\\] {
  height: 67px;
}
.h-\\[9px\\] {
  height: 9px;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[26px\\] {
  max-height: 26px;
}
.max-h-\\[30px\\] {
  max-height: 30px;
}
.max-h-\\[32px\\] {
  max-height: 32px;
}
.max-h-\\[55px\\] {
  max-height: 55px;
}
.min-h-\\[130px\\] {
  min-height: 130px;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[305px\\] {
  min-height: 305px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[40px\\] {
  min-height: 40px;
}
.min-h-\\[45px\\] {
  min-height: 45px;
}
.min-h-\\[511px\\] {
  min-height: 511px;
}
.min-h-\\[55px\\] {
  min-height: 55px;
}
.min-h-\\[calc\\(100vh_-_132px\\)\\] {
  min-height: calc(100vh - 132px);
}
.min-h-min {
  min-height: min-content;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-full {
  width: 100% !important;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-28 {
  width: 7rem;
}
.w-3\\/5 {
  width: 60%;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[23\\%\\] {
  width: 23%;
}
.w-\\[45\\%\\] {
  width: 45%;
}
.w-\\[48px\\] {
  width: 48px;
}
.w-\\[55\\%\\] {
  width: 55%;
}
.w-\\[55px\\] {
  width: 55px;
}
.w-\\[60\\%\\] {
  width: 60%;
}
.w-\\[64px\\] {
  width: 64px;
}
.w-\\[67px\\] {
  width: 67px;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[9px\\] {
  width: 9px;
}
.w-full {
  width: 100%;
}
.min-w-\\[130px\\] {
  min-width: 130px;
}
.min-w-\\[163px\\] {
  min-width: 163px;
}
.min-w-\\[55px\\] {
  min-width: 55px;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[32px\\] {
  max-width: 32px;
}
.max-w-\\[38px\\] {
  max-width: 38px;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[55px\\] {
  max-width: 55px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[80px\\] {
  max-width: 80px;
}
.max-w-\\[85px\\] {
  max-width: 85px;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-screen-xl {
  max-width: 1280px;
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-11 {
  gap: 2.75rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-20 {
  gap: 5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.self-start {
  align-self: flex-start;
}
.overflow-auto {
  overflow: auto;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[50\\%\\] {
  border-radius: 50%;
}
.rounded-\\[50px\\] {
  border-radius: 50px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-dashed {
  border-style: dashed;
}
.border-\\[\\#002366\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 35 102 / var(--tw-border-opacity));
}
.border-\\[\\#1B7C18\\] {
  --tw-border-opacity: 1;
  border-color: rgb(27 124 24 / var(--tw-border-opacity));
}
.border-\\[\\#6178A5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(97 120 165 / var(--tw-border-opacity));
}
.border-\\[\\#ACA8A8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(172 168 168 / var(--tw-border-opacity));
}
.border-\\[\\#B6B5B5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(182 181 181 / var(--tw-border-opacity));
}
.border-\\[rgb\\(182\\2c 181\\2c 181\\)\\] {
  --tw-border-opacity: 1;
  border-color: rgb(182 181 181 / var(--tw-border-opacity));
}
.bg-\\[\\#002366\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 35 102 / var(--tw-bg-opacity));
}
.bg-\\[\\#011842\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(1 24 66 / var(--tw-bg-opacity));
}
.bg-\\[\\#333333\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(51 51 51 / var(--tw-bg-opacity));
}
.bg-\\[\\#D6F8DD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(214 248 221 / var(--tw-bg-opacity));
}
.bg-\\[\\#D8D8D8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(216 216 216 / var(--tw-bg-opacity));
}
.bg-\\[\\#E3E0E0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(227 224 224 / var(--tw-bg-opacity));
}
.bg-\\[\\#EEEEEE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
}
.bg-\\[\\#EEE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
}
.bg-\\[\\#F8FAFC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity));
}
.bg-\\[\\#fafafa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-\\[\\#fff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-\\[url\\(\\'\\/public\\/images\\/backJp\\.jpg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-blue-500 {
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500 {
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500 {
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500 {
  --tw-gradient-from: #ec4899 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 72 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-emerald-500 {
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}
.to-indigo-500 {
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.to-purple-500 {
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-teal-500 {
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[30px\\] {
  padding: 30px;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-9 {
  padding-bottom: 2.25rem;
}
.pb-\\[18px\\] {
  padding-bottom: 18px;
}
.pe-3 {
  padding-inline-end: 0.75rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-28 {
  padding-top: 7rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-\\[17px\\] {
  padding-top: 17px;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-top {
  vertical-align: top;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[25px\\] {
  font-size: 25px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extralight {
  font-weight: 200;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.leading-\\[45px\\] {
  line-height: 45px;
}
.text-\\[\\#002366\\] {
  --tw-text-opacity: 1;
  color: rgb(0 35 102 / var(--tw-text-opacity));
}
.text-\\[\\#047B25\\] {
  --tw-text-opacity: 1;
  color: rgb(4 123 37 / var(--tw-text-opacity));
}
.text-\\[\\#1B7C18\\] {
  --tw-text-opacity: 1;
  color: rgb(27 124 24 / var(--tw-text-opacity));
}
.text-\\[\\#52525B\\] {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity));
}
.text-\\[\\#64748B\\] {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}
.text-\\[\\#656b76\\] {
  --tw-text-opacity: 1;
  color: rgb(101 107 118 / var(--tw-text-opacity));
}
.text-\\[\\#848484\\] {
  --tw-text-opacity: 1;
  color: rgb(132 132 132 / var(--tw-text-opacity));
}
.text-\\[\\#CBD5E1\\] {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}
.text-\\[\\#FC0303\\] {
  --tw-text-opacity: 1;
  color: rgb(252 3 3 / var(--tw-text-opacity));
}
.text-\\[\\#FFA500\\] {
  --tw-text-opacity: 1;
  color: rgb(255 165 0 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-300 {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-75 {
  opacity: 0.75;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 700;
  font-style: bold;
}
@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
  font-weight: 200;
  font-style: normal;
}

@font-face {
  font-family: "Muli";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Muli";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Muli";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Muli";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
  font-weight: 200;
  font-style: normal;
}
/* @font-face {
  font-family: "Mulish";
  src: url("/public/font/Mulish-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
} */

* {
  font-family: "Poppins", sans-serif !important;
}

.font-Mulish {
  font-family: "Muli" !important;
  /* letter-spacing: 1px; */
}
.adminOffers  .ant-tabs-nav {
  margin: 0 !important;
}
.affilateOfferLink {
    white-space: nowrap;
    width: 55px;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
}
.adminOffers .ant-tabs-nav-list p {
  margin-bottom: 0;
  color: #002366;
}
.paymentSelect span.anticon.anticon-down{
  display: none !important;
}
.paymentSelect  .ant-select-selector:after {
  width: 220px;
  position: relative;
  left: -63px;

}
.paymentSelect span.ant-select-selection-item {
  overflow: visible !important;
  padding-inline-end: 0 !important;
}
/* .adminOffers .ant-tabs-tab-active ,.adminOffers .ant-tabs-tab-active p {
  background-color: #002366 !important;
  color: #002366 !important;
  border:none !important
} */
.ant-tabs-ink-bar.ant-tabs-ink-bar-animated{
  background: #002366
}
.adminOffers .ant-tabs-content-holder {
  padding-top: 16px;
  background: #eeeeee;
}
.adminOffers .ant-tabs-extra-content {
  padding: 4px;
}
.adminOffers .ant-tabs-nav-list .ant-tabs-tab {
  padding: 0 16px !important;
  /* border-left: 1px solid #ACA8A8; */
  margin: 0 !important;
}
.login_rememberme .ant-row {
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
}
.login_rememberme .ant-col {
  padding: 0 !important;
}

.rowPointer .ant-table-tbody .ant-table-row{
  cursor: pointer;
}



.userTable table,
.userTable th,
.userTable tr {
  border-radius: 0 !important;
}

.userTable table th {
  background-color: #cecdcd !important;
}
.offerTable table th {
  background-color: #002366 !important;
  color: #fff !important;
}

.singleOfferTable table td {
  background: #fafafa !important;
}
/* .userTable table tbody tr:nth-child(even) {
  background-color: #e7e7e759;
} */
.user_Search .ant-input-search-button {
  background: #002366;
}
.gradTotalUser {
  background-image: linear-gradient(
    to right,
    rgba(0, 35, 102, 1),
    rgba(0, 35, 102, 0.71)
  );
}
.gradTotalRevenue {
  background-image: linear-gradient(
    to right,
    rgba(4, 123, 37, 1),
    rgba(4, 123, 37, 0.62)
  );
}
.gradTotalAffiliate {
  background-image: linear-gradient(
    to right,
    rgba(212, 138, 3, 1),
    rgba(255, 165, 0, 0.71)
  );
}
.profileTable table {
  display: flex;
}
.profileTable thead.ant-table-thead ,.profileTable tbody.ant-table-tbody  {
  width: 40%;
  
}
.profileTable thead.ant-table-thead tr,.profileTable tbody.ant-table-tbody tr {
  display: flex;
  flex-direction: column;
  background-color: transparent;
  border:none;
}
.profileTable tbody.ant-table-tbody tr:hover td{ 
  background-color: transparent !important;
}
.profileTable thead.ant-table-thead th,.profileTable tbody.ant-table-tbody td {
  background-color: transparent;
  border:none;
  border-inline-end: none !important;
}
.gradadminFee {
  background-image: linear-gradient(
    to right,
    rgba(214, 20, 20, 1),
    rgba(252, 84, 84, 1)
  );
}
.offerTabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #1f57a1;
}

.offerTabs .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
  background: #1f57a1 !important;
}
.ant-popconfirm-buttons .ant-btn-primary {
  background: blue;
}
.paymentMethods .ant-radio-wrapper .ant-radio{
  width: 4% !important;
}
.paymentMethods span.ant-radio-inner {
  width: 20px !important;
  height: 20px !important;
}
.paymentMethodsModal .ant-btn-primary {
  background: #002366;
}
.paymentMethods .ant-radio-wrapper span {
  width: 96%;
}
.removeArrow .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
  display: none;
}
.removeArrow .ant-tabs-tab-btn {
  font-family: "Muli" !important;
  font-weight: 600;
  font-size: 18px;
}

.removeArrow .ant-tabs-tab {
  padding: 0px;
}
.removeArrow .ant-tabs-nav {
  margin-bottom: 14px;
}
.removeArrow .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #002366;
}
.newsAccordian .ant-collapse-header {
  align-items: center !important;
}

.newsAccordian span.anticon.anticon-plus-circle.ant-collapse-arrow svg,
.newsAccordian span.anticon.anticon-minus-circle.ant-collapse-arrow svg {
  width: 30px;
  height: 30px;
}
.newsAccordian .ant-collapse-header {
  background-color: #eeeeee;
  margin-top: 20px;
  border-radius: 5px !important;
}

.newsAccordian {
  border: none;
}
.newsAccordian .ant-collapse-item {
  border: transparent;
}
.newsAccordian
  .ant-collapse-item.ant-collapse-item-active
  .ant-collapse-header {
  background-color: #002366;
  color: white;
}

.newsAccordian .ant-collapse-content.ant-collapse-content-active {
  border: transparent;
}

.newsSwitch.ant-switch-checked {
  background: #002366 !important;
}
.newsSwitch {
  background-color: #777;
}

.ant-modal-wrap.ant-modal-centered {
  background-color: rgba(1, 13, 35, 0.69);
}
.modal_parent_wrapper .ant-modal-content{
  margin-bottom: 50px;
  padding: 0 !important;
}
.modal_parent_wrapper span.ant-modal-close-x {
  color: #fff;
}
.modal_parent_wrapper .ant-modal-footer {
  text-align: center !important;
  margin-bottom: 10px;
}
.modal_parent_wrapper .ant-modal-footer button {
  margin-bottom: 30px;
}

.modal_parent_wrapper .ant-select .ant-select-selector {
  height: 40px !important;
  border-radius: 16px;
  align-items: center;
}
.modal_parent_wrapper .ant-picker {
  height: 40px !important;
  border-radius: 16px;
  align-items: center;
}
.modal_parent_wrapper .ant-form-item-explain-error {
  margin-bottom: 10px;
}
.color_switch label.css-1uxen9d-Switch {
  justify-content: center;
}
.color_switch .css-z8ecbu-Switch {
  border: 1px solid #fff !important;
  border-radius: 2px !important;
  background: transparent;
}
.color_switch input:checked ~ .css-z8ecbu-Switch {
  background: transparent !important;
}

.color_switch .css-g89m8z-Box {
  top: -2px;
  width: 19px;
  height: 21px;
  inset-inline-start: -2px !important;
  border-radius: 0px;
}
.ant-table-wrapper .ant-table-cell-ellipsis {
  /* overflow: hidden; */
  white-space: normal;
  text-overflow: unset;
  word-break: unset;
}
th.ant-table-cell.ant-table-cell-ellipsis.ant-table-column-has-sorters {
  padding: 15px !important;
}
.content-form-wrapper .ant-upload.ant-upload-select span.ant-upload div {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* .content-form-wrapper .ant-upload.ant-upload-select span.ant-upload div div {
  margin-top: 0 !important;
  background: #002366;
  color: #fff;
  border-radius: 50px;
  padding: 10px 30px;
  text-transform: uppercase;
} */
.modal_parent_wrapper .ant-upload.ant-upload-select span.anticon.anticon-plus {
  display: none;
}
/* .fullWidthUpload .ant-upload.ant-upload-select {
    width: 402px;
    
  } */

.fullWidthUpload .ant-upload-list .ant-upload.ant-upload-select {
  width: 100%;
  border-color: #002366;
}

.sidebarItems li.ant-menu-item {
  height: 80px;
  border-bottom: 1px solid;
  border-radius: 0px;
  color: white;
  padding-left: 24px;
  background-color: transparent;
}
/* .sidebarItems li.ant-menu-item .ant-menu-item-icon {
  background-color: transparent;
} */
.sidebarItems .ant-menu-item .ant-menu-item-icon {
  min-width: 55px;
  max-width: 55px;
  width: 100%;
  min-height: 55px;
  max-height: 55px;
  height: 100%;
  background-color: transparent;
}
.sidebarItems li.ant-menu-item .ant-menu-item-icon img {
  filter: brightness(0) invert(100%);
}
.sidebarItems li.ant-menu-item.ant-menu-item-selected .ant-menu-item-icon {
  background: #d8d8d8;
}
.sidebarItems li.ant-menu-item.ant-menu-item-selected .ant-menu-item-icon img {
  filter: none;
}
/* .sidebarItems li.ant-menu-item.ant-menu-item-selected .ant-menu-item-icon img{
background-color: red;
} */

.ant-menu-inline-collapsed.sidebarItems .ant-menu-item {
  padding-left: 7px;
  align-items: center;
  display: flex;
}
.sidebarItems li.ant-menu-item.ant-menu-item-selected {
  border-left: 7px solid #d8d8d8;
  margin: 0px 0px !important;
  padding-left: 16px !important;
}
.sidebarItems li.ant-menu-item:hover {
  color: #fff !important;
}
.sidebarItems li.ant-menu-item:active {
  background: transparent !important;
}
.sidebarItems.ant-menu-inline .ant-menu-item {
  margin: 0px 0px !important;
  width: 100%;
  white-space: normal;
  line-height: normal;
}
span.ant-select-selection-item {
  font-weight: bold !important;
}
.affiliateOfferWrapper .ant-tabs-nav {
  background-color: #fff;
}
.affiliateOfferWrapper .ant-tabs-tab {
  margin: 0 !important;
  padding: 0 !important;
  border-left: 1px solid #aca8a8;
}
.affiliateOfferWrapper .ant-tabs-tab:first-child {
  border: none !important;
}
/* .affiliateOfferWrapper .ant-tabs-tab:last-child{
  margin: 0 !important;
  padding: 0 !important;
  border-right: 1px solid #ACA8A8
} */

.affiliateOfferWrapper .ant-tabs-tab-active .ant-tabs-tab-btn {
  background: #002366;
  color: #fff !important;
}

/* th{
  width: 136px !important;
} */
th:not(.ant-picker-content th) {
  width: 136px;
}

.affiliateOfferWrapper .ant-tabs-tab .ant-tabs-tab-btn {
  margin: 0 !important;
  padding: 20px 20px !important;
  min-width: 137px;
  text-align: center;
}
.affiliateOfferWrapper .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
  display: none;
}

.affiliateOfferCheckbox span.ant-checkbox-inner {
  background-color: #eeeeee !important;
  height: 26px;
  width: 26px;
  direction: rtl;
}
.affiliateOfferCheckbox .ant-checkbox-checked span.ant-checkbox-inner {
  background-color: #002366 !important;
}
.affiliateOfferCheckbox .ant-checkbox .ant-checkbox-inner:after {
  inset-inline-start: 0.5%;
  width: 14.714286px;
  height: 7.142857px;
}

.affiliateOfferCheckbox .ant-checkbox-checked .ant-checkbox-inner:after {
  opacity: 1;
  transform: rotate(324deg) scale(1) translate(0%, -100%);
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
}

.affiliateOfferSearch .ant-input-search-button,
.affiliateOfferSearch .ant-input-search-button:hover {
  box-shadow: none !important;
  background-color: #002366 !important ;
}

.affiliateTableStar svg {
  height: 20px;
  width: 20px;
}
.ant-modal-wrap {
  width: 77%;
  right: 0 !important;
  left: auto !important;
}
.modal_closeIcon_wrapper .ant-modal-content button.ant-modal-close {
  border-radius: 100% !important;
  background: black !important;
}

.fullwidth_modal_wrapper {
  width: calc(100% - 50px) !important;
}
.reportsTableCell .ant-table-thead th{
  background-color: #dadada !important;
  text-align: start !important;
}

.reportsTableCell .ant-table-tbody td{
  text-align: end !important  ;
}

.light_input_fields .ant-form-item-control-input input{
  color: rgba(24, 22, 23, 0.8) !important
}

.light_input_fields .ant-form-item-control-input textarea{
  color: rgba(24, 22, 23, 0.8) !important
}
.light_input_fields .ant-form-item-control-input .ant-select-selector .ant-select-selection-item{
  color: rgba(24, 22, 23, 0.8) !important
}



/* active:border-l-[7px] border-[#D8D8D8] */
@media screen and (max-width: 2600px) {
  .signup_col_with_bg {
    padding-top: 19rem;
  }
}   

@media screen and (max-width: 1920px) {
  .signup_col_with_bg {
    padding-top: 7rem;
  }
}
@media screen and (max-width: 1660px) {
  .signup_col_with_bg {
    padding-top: 2rem;
  }
}

@media screen and (max-width: 426px) {
  .hideOnMobile{
    display: none;
  }
  .login-form-forgot{
    float:none;
    
  }
}
@media screen and (max-width: 767px) {
  .hideOnMobilesignup{
    display: none;
    
  }
  
}
@media screen and (max-width: 426px) {
  .showOnMobile{
    width: 100% !important;

  }
  
}

@media screen and (min-width: 768px) {
  .showOnMobile{
    width: 55%;

  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1366px) {
  .reduce_font_size p {
    font-size: 14px;
}
.reduce_font_size h6 {
  font-size: 16px;
}
}

@media (max-width: 768px) {
  .ant-modal-wrap {
    width: 100% !important;
    right: 0 !important;
    left: 0 !important;
  }
  .ant-table-pagination-right {
    justify-content: center !important;
  }
  .ant-picker-panels {
    flex-direction: column !important;
  }
  .ant-tabs-extra-content {
    width: 50%;
  }
  .ant-form-item-control-input-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .ant-table-cell-fix-left {
    width: 100px !important;
  }
  h1{
    font-size: 18px !important;
  }
  th,td{
    font-size: 12px !important;
  }
  .sidebarItems{
    font-size: 12px !important;
  }
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}

.before\\:top-0::before {
  content: var(--tw-content);
  top: 0px;
}

.before\\:h-2::before {
  content: var(--tw-content);
  height: 0.5rem;
}

.before\\:w-2::before {
  content: var(--tw-content);
  width: 0.5rem;
}

.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

:is(.dark .dark\\:brightness-\\[1\\]) {
  --tw-brightness: brightness(1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

:is(.dark .dark\\:invert-\\[1\\]) {
  --tw-invert: invert(1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

@media (min-width: 640px) {

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:w-1\\/2 {
    width: 50%;
  }

  .sm\\:w-1\\/3 {
    width: 33.333333%;
  }

  .sm\\:w-2\\/3 {
    width: 66.666667%;
  }

  .sm\\:w-\\[170px\\] {
    width: 170px;
  }

  .sm\\:w-\\[35\\%\\] {
    width: 35%;
  }

  .sm\\:w-\\[48\\%\\] {
    width: 48%;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-20 {
    gap: 5rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:self-center {
    align-self: center;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:text-center {
    text-align: center;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}

@media (min-width: 768px) {

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-screen {
    height: 100vh;
  }

  .md\\:min-h-\\[511px\\] {
    min-height: 511px;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .md\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .md\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .md\\:w-\\[77\\%\\] {
    width: 77%;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:min-w-\\[230px\\] {
    min-width: 230px;
  }

  .md\\:max-w-\\[290px\\] {
    max-width: 290px;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:overflow-visible {
    overflow: visible;
  }

  .md\\:text-clip {
    text-overflow: clip;
  }

  .md\\:whitespace-normal {
    white-space: normal;
  }

  .md\\:border-r-2 {
    border-right-width: 2px;
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\\:pb-11 {
    padding-bottom: 2.75rem;
  }

  .md\\:pb-9 {
    padding-bottom: 2.25rem;
  }

  .md\\:pl-5 {
    padding-left: 1.25rem;
  }

  .md\\:pt-28 {
    padding-top: 7rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:block {
    display: block;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-1\\/4 {
    width: 25%;
  }

  .lg\\:w-3\\/4 {
    width: 75%;
  }

  .lg\\:w-\\[30\\%\\] {
    width: 30%;
  }

  .lg\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .lg\\:max-w-\\[249px\\] {
    max-width: 249px;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./src/common/styles/index.css","<no source>"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,sBAAsB;EACtB,+DAA4D;EAC5D,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,+DAAgE;EAChE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAAkE;EAClE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAAyD;EACzD,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,+DAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,+DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gEAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;GAKG;;AAEH;EACE,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;;AAEb;AACA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;;;;GAIG;AACH;EACE;AACF;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;;;AAIA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;AACA;;GAEG;AACH;EACE,mBAAmB;AACrB;AACA;EACE;;;;GAIC;AACH;AACA;EACE;;;;GAIC;AACH;AACA;EACE;;;;GAIC;AACH;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;;AAEZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,kCAAkC;AACpC;AACA;EACE;;;;GAIC;AACH;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;AACA;EACE,mBAAmB;EAInB,qBAAqB;AAHvB;AAKA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;;;;GAOG;AACH;EACE,aAAa;AACf;AACA;;;KAGK;;AAEL;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;;GAEG;AACH;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;;GAEG;;AAEH;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;;;;GAIG;;AAEH;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;GAEG;AACH;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,uDAAuD;EACvD,6DAA6D;AAC/D;;AAEA;;EAEE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;AACF;;AAEA;EACE;AACF;AACA;EACE;AACF;;;;AAIA,2CAA2C;AAC3C;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;;EAEZ;AACF;AACA;EACE;IACE,aAAa;;EAEf;;AAEF;AACA;EACE;IACE,sBAAsB;;EAExB;;AAEF;;AAEA;EACE;IACE,UAAU;;EAEZ;AACF;AACA;EACE;IACE,eAAe;AACnB;AACA;EACE,eAAe;AACjB;AACA;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;EAIA;IACE,kCAAkC;EACpC;EAIA;IACE,iCAAiC;EACnC;EAIA;IACE,UAAU;EACZ;EAIA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;EAIA;IACE,uBAAuB;EACzB;EAIA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AA5CF;;AAhmBA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,iBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,+BCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;;EAAA;IAAA,iBCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;CAAA;;ADAA;;EAAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,qBCAA;IDAA;GCAA;;EDAA;IAAA,sBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,iBCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,gBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,gBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;CAAA;;ADAA;;EAAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;CAAA;;ADAA;;EAAA;IAAA;GCAA;CAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"/public/font/Poppins-Bold.ttf\") format(\"truetype\");\n  font-weight: 700;\n  font-style: bold;\n}\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"/public/font/Poppins-SemiBold.ttf\") format(\"truetype\");\n  font-weight: 600;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"/public/font/Poppins-Medium.ttf\") format(\"truetype\");\n  font-weight: 500;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"/public/font/Poppins-Regular.ttf\") format(\"truetype\");\n  font-weight: 400;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"/public/font/Poppins-Light.ttf\") format(\"truetype\");\n  font-weight: 300;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"/public/font/Poppins-ExtraLight.ttf\") format(\"truetype\");\n  font-weight: 200;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Muli\";\n  src: url(\"/public/font/Muli-Bold.ttf\") format(\"truetype\");\n  font-weight: 700;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Muli\";\n  src: url(\"/public/font/Muli-SemiBold.ttf\") format(\"truetype\");\n  font-weight: 600;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Muli\";\n  src: url(\"/public/font/Muli-Light.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Muli\";\n  src: url(\"/public/font/Muli-ExtraLight.ttf\") format(\"truetype\");\n  font-weight: 200;\n  font-style: normal;\n}\n/* @font-face {\n  font-family: \"Mulish\";\n  src: url(\"/public/font/Mulish-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n} */\n\n* {\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.font-Mulish {\n  font-family: \"Muli\" !important;\n  /* letter-spacing: 1px; */\n}\n.adminOffers  .ant-tabs-nav {\n  margin: 0 !important;\n}\n.affilateOfferLink {\n    white-space: nowrap;\n    width: 55px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    position: relative;\n}\n.adminOffers .ant-tabs-nav-list p {\n  margin-bottom: 0;\n  color: #002366;\n}\n.paymentSelect span.anticon.anticon-down{\n  display: none !important;\n}\n.paymentSelect  .ant-select-selector:after {\n  width: 220px;\n  position: relative;\n  left: -63px;\n\n}\n.paymentSelect span.ant-select-selection-item {\n  overflow: visible !important;\n  padding-inline-end: 0 !important;\n}\n/* .adminOffers .ant-tabs-tab-active ,.adminOffers .ant-tabs-tab-active p {\n  background-color: #002366 !important;\n  color: #002366 !important;\n  border:none !important\n} */\n.ant-tabs-ink-bar.ant-tabs-ink-bar-animated{\n  background: #002366\n}\n.adminOffers .ant-tabs-content-holder {\n  padding-top: 16px;\n  background: #eeeeee;\n}\n.adminOffers .ant-tabs-extra-content {\n  padding: 4px;\n}\n.adminOffers .ant-tabs-nav-list .ant-tabs-tab {\n  padding: 0 16px !important;\n  /* border-left: 1px solid #ACA8A8; */\n  margin: 0 !important;\n}\n.login_rememberme .ant-row {\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n  align-items: center;\n}\n.login_rememberme .ant-col {\n  padding: 0 !important;\n}\n\n.rowPointer .ant-table-tbody .ant-table-row{\n  cursor: pointer;\n}\n\n\n\n.userTable table,\n.userTable th,\n.userTable tr {\n  border-radius: 0 !important;\n}\n\n.userTable table th {\n  background-color: #cecdcd !important;\n}\n.offerTable table th {\n  background-color: #002366 !important;\n  color: #fff !important;\n}\n\n.singleOfferTable table td {\n  background: #fafafa !important;\n}\n/* .userTable table tbody tr:nth-child(even) {\n  background-color: #e7e7e759;\n} */\n.user_Search .ant-input-search-button {\n  background: #002366;\n}\n.gradTotalUser {\n  background-image: linear-gradient(\n    to right,\n    rgba(0, 35, 102, 1),\n    rgba(0, 35, 102, 0.71)\n  );\n}\n.gradTotalRevenue {\n  background-image: linear-gradient(\n    to right,\n    rgba(4, 123, 37, 1),\n    rgba(4, 123, 37, 0.62)\n  );\n}\n.gradTotalAffiliate {\n  background-image: linear-gradient(\n    to right,\n    rgba(212, 138, 3, 1),\n    rgba(255, 165, 0, 0.71)\n  );\n}\n.profileTable table {\n  display: flex;\n}\n.profileTable thead.ant-table-thead ,.profileTable tbody.ant-table-tbody  {\n  width: 40%;\n  \n}\n.profileTable thead.ant-table-thead tr,.profileTable tbody.ant-table-tbody tr {\n  display: flex;\n  flex-direction: column;\n  background-color: transparent;\n  border:none;\n}\n.profileTable tbody.ant-table-tbody tr:hover td{ \n  background-color: transparent !important;\n}\n.profileTable thead.ant-table-thead th,.profileTable tbody.ant-table-tbody td {\n  background-color: transparent;\n  border:none;\n  border-inline-end: none !important;\n}\n.gradadminFee {\n  background-image: linear-gradient(\n    to right,\n    rgba(214, 20, 20, 1),\n    rgba(252, 84, 84, 1)\n  );\n}\n.offerTabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #1f57a1;\n}\n\n.offerTabs .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {\n  background: #1f57a1 !important;\n}\n.ant-popconfirm-buttons .ant-btn-primary {\n  background: blue;\n}\n.paymentMethods .ant-radio-wrapper .ant-radio{\n  width: 4% !important;\n}\n.paymentMethods span.ant-radio-inner {\n  width: 20px !important;\n  height: 20px !important;\n}\n.paymentMethodsModal .ant-btn-primary {\n  background: #002366;\n}\n.paymentMethods .ant-radio-wrapper span {\n  width: 96%;\n}\n.removeArrow .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {\n  display: none;\n}\n.removeArrow .ant-tabs-tab-btn {\n  font-family: \"Muli\" !important;\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.removeArrow .ant-tabs-tab {\n  padding: 0px;\n}\n.removeArrow .ant-tabs-nav {\n  margin-bottom: 14px;\n}\n.removeArrow .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #002366;\n}\n.newsAccordian .ant-collapse-header {\n  align-items: center !important;\n}\n\n.newsAccordian span.anticon.anticon-plus-circle.ant-collapse-arrow svg,\n.newsAccordian span.anticon.anticon-minus-circle.ant-collapse-arrow svg {\n  width: 30px;\n  height: 30px;\n}\n.newsAccordian .ant-collapse-header {\n  background-color: #eeeeee;\n  margin-top: 20px;\n  border-radius: 5px !important;\n}\n\n.newsAccordian {\n  border: none;\n}\n.newsAccordian .ant-collapse-item {\n  border: transparent;\n}\n.newsAccordian\n  .ant-collapse-item.ant-collapse-item-active\n  .ant-collapse-header {\n  background-color: #002366;\n  color: white;\n}\n\n.newsAccordian .ant-collapse-content.ant-collapse-content-active {\n  border: transparent;\n}\n\n.newsSwitch.ant-switch-checked {\n  background: #002366 !important;\n}\n.newsSwitch {\n  background-color: #777;\n}\n\n.ant-modal-wrap.ant-modal-centered {\n  background-color: rgba(1, 13, 35, 0.69);\n}\n.modal_parent_wrapper .ant-modal-content{\n  margin-bottom: 50px;\n}\n\n.modal_parent_wrapper .ant-modal-content {\n  padding: 0 !important;\n}\n.modal_parent_wrapper span.ant-modal-close-x {\n  color: #fff;\n}\n.modal_parent_wrapper .ant-modal-footer {\n  text-align: center !important;\n  margin-bottom: 10px;\n}\n.modal_parent_wrapper .ant-modal-footer button {\n  margin-bottom: 30px;\n}\n\n.modal_parent_wrapper .ant-select .ant-select-selector {\n  height: 40px !important;\n  border-radius: 16px;\n  align-items: center;\n}\n.modal_parent_wrapper .ant-picker {\n  height: 40px !important;\n  border-radius: 16px;\n  align-items: center;\n}\n.modal_parent_wrapper .ant-form-item-explain-error {\n  margin-bottom: 10px;\n}\n.color_switch label.css-1uxen9d-Switch {\n  justify-content: center;\n}\n.color_switch .css-z8ecbu-Switch {\n  border: 1px solid #fff !important;\n  border-radius: 2px !important;\n  background: transparent;\n}\n.color_switch input:checked ~ .css-z8ecbu-Switch {\n  background: transparent !important;\n}\n\n.color_switch .css-g89m8z-Box {\n  top: -2px;\n  width: 19px;\n  height: 21px;\n  inset-inline-start: -2px !important;\n  border-radius: 0px;\n}\n.ant-table-wrapper .ant-table-cell-ellipsis {\n  /* overflow: hidden; */\n  white-space: normal;\n  text-overflow: unset;\n  word-break: unset;\n}\nth.ant-table-cell.ant-table-cell-ellipsis.ant-table-column-has-sorters {\n  padding: 15px !important;\n}\n.content-form-wrapper .ant-upload.ant-upload-select span.ant-upload div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n/* .content-form-wrapper .ant-upload.ant-upload-select span.ant-upload div div {\n  margin-top: 0 !important;\n  background: #002366;\n  color: #fff;\n  border-radius: 50px;\n  padding: 10px 30px;\n  text-transform: uppercase;\n} */\n.modal_parent_wrapper .ant-upload.ant-upload-select span.anticon.anticon-plus {\n  display: none;\n}\n/* .fullWidthUpload .ant-upload.ant-upload-select {\n    width: 402px;\n    \n  } */\n\n.fullWidthUpload .ant-upload-list .ant-upload.ant-upload-select {\n  width: 100%;\n  border-color: #002366;\n}\n\n.sidebarItems li.ant-menu-item {\n  height: 80px;\n  border-bottom: 1px solid;\n  border-radius: 0px;\n  color: white;\n  padding-left: 24px;\n  background-color: transparent;\n}\n/* .sidebarItems li.ant-menu-item .ant-menu-item-icon {\n  background-color: transparent;\n} */\n.sidebarItems .ant-menu-item .ant-menu-item-icon {\n  min-width: 55px;\n  max-width: 55px;\n  width: 100%;\n  min-height: 55px;\n  max-height: 55px;\n  height: 100%;\n  background-color: transparent;\n}\n.sidebarItems li.ant-menu-item .ant-menu-item-icon img {\n  filter: brightness(0) invert(100%);\n}\n.sidebarItems li.ant-menu-item.ant-menu-item-selected .ant-menu-item-icon {\n  background: #d8d8d8;\n}\n.sidebarItems li.ant-menu-item.ant-menu-item-selected .ant-menu-item-icon img {\n  filter: none;\n}\n/* .sidebarItems li.ant-menu-item.ant-menu-item-selected .ant-menu-item-icon img{\nbackground-color: red;\n} */\n\n.ant-menu-inline-collapsed.sidebarItems .ant-menu-item {\n  padding-left: 7px;\n  align-items: center;\n  display: flex;\n}\n.sidebarItems li.ant-menu-item.ant-menu-item-selected {\n  border-left: 7px solid #d8d8d8;\n  margin: 0px 0px !important;\n  padding-left: 16px !important;\n}\n.sidebarItems li.ant-menu-item:hover {\n  color: #fff !important;\n}\n.sidebarItems li.ant-menu-item:active {\n  background: transparent !important;\n}\n.sidebarItems.ant-menu-inline .ant-menu-item {\n  margin: 0px 0px !important;\n  width: 100%;\n  white-space: normal;\n  line-height: normal;\n}\nspan.ant-select-selection-item {\n  font-weight: bold !important;\n}\n.affiliateOfferWrapper .ant-tabs-nav {\n  background-color: #fff;\n}\n.affiliateOfferWrapper .ant-tabs-tab {\n  margin: 0 !important;\n  padding: 0 !important;\n  border-left: 1px solid #aca8a8;\n}\n.affiliateOfferWrapper .ant-tabs-tab:first-child {\n  border: none !important;\n}\n/* .affiliateOfferWrapper .ant-tabs-tab:last-child{\n  margin: 0 !important;\n  padding: 0 !important;\n  border-right: 1px solid #ACA8A8\n} */\n\n.affiliateOfferWrapper .ant-tabs-tab-active .ant-tabs-tab-btn {\n  background: #002366;\n  color: #fff !important;\n}\n\n/* th{\n  width: 136px !important;\n} */\nth:not(.ant-picker-content th) {\n  width: 136px;\n}\n\n.affiliateOfferWrapper .ant-tabs-tab .ant-tabs-tab-btn {\n  margin: 0 !important;\n  padding: 20px 20px !important;\n  min-width: 137px;\n  text-align: center;\n}\n.affiliateOfferWrapper .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {\n  display: none;\n}\n\n.affiliateOfferCheckbox span.ant-checkbox-inner {\n  background-color: #eeeeee !important;\n  height: 26px;\n  width: 26px;\n  direction: rtl;\n}\n.affiliateOfferCheckbox .ant-checkbox-checked span.ant-checkbox-inner {\n  background-color: #002366 !important;\n}\n.affiliateOfferCheckbox .ant-checkbox .ant-checkbox-inner:after {\n  inset-inline-start: 0.5%;\n  width: 14.714286px;\n  height: 7.142857px;\n}\n\n.affiliateOfferCheckbox .ant-checkbox-checked .ant-checkbox-inner:after {\n  opacity: 1;\n  transform: rotate(324deg) scale(1) translate(0%, -100%);\n  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n}\n\n.affiliateOfferSearch .ant-input-search-button,\n.affiliateOfferSearch .ant-input-search-button:hover {\n  box-shadow: none !important;\n  background-color: #002366 !important ;\n}\n\n.affiliateTableStar svg {\n  height: 20px;\n  width: 20px;\n}\n.ant-modal-wrap {\n  width: 77%;\n  right: 0 !important;\n  left: auto !important;\n}\n.modal_closeIcon_wrapper .ant-modal-content button.ant-modal-close {\n  border-radius: 100% !important;\n  background: black !important;\n}\n\n.fullwidth_modal_wrapper {\n  width: calc(100% - 50px) !important;\n}\n.reportsTableCell .ant-table-thead th{\n  background-color: #dadada !important;\n  text-align: start !important;\n}\n\n.reportsTableCell .ant-table-tbody td{\n  text-align: end !important  ;\n}\n\n.light_input_fields .ant-form-item-control-input input{\n  color: rgba(24, 22, 23, 0.8) !important\n}\n\n.light_input_fields .ant-form-item-control-input textarea{\n  color: rgba(24, 22, 23, 0.8) !important\n}\n.light_input_fields .ant-form-item-control-input .ant-select-selector .ant-select-selection-item{\n  color: rgba(24, 22, 23, 0.8) !important\n}\n\n\n\n/* active:border-l-[7px] border-[#D8D8D8] */\n@media screen and (max-width: 2600px) {\n  .signup_col_with_bg {\n    padding-top: 19rem;\n  }\n}   \n\n@media screen and (max-width: 1920px) {\n  .signup_col_with_bg {\n    padding-top: 7rem;\n  }\n}\n@media screen and (max-width: 1660px) {\n  .signup_col_with_bg {\n    padding-top: 2rem;\n  }\n}\n\n@media screen and (max-width: 426px) {\n  .hideOnMobile{\n    display: none;\n  }\n  .login-form-forgot{\n    float:none;\n    \n  }\n}\n@media screen and (max-width: 767px) {\n  .hideOnMobilesignup{\n    display: none;\n    \n  }\n  \n}\n@media screen and (max-width: 426px) {\n  .showOnMobile{\n    width: 100% !important;\n\n  }\n  \n}\n\n@media screen and (min-width: 768px) {\n  .showOnMobile{\n    width: 55%;\n\n  }\n}\n@media only screen and (min-device-width: 768px) and (max-device-width: 1366px) {\n  .reduce_font_size p {\n    font-size: 14px;\n}\n.reduce_font_size h6 {\n  font-size: 16px;\n}\n}\n\n@media (max-width: 768px) {\n  .ant-modal-wrap {\n    width: 100% !important;\n    right: 0 !important;\n    left: 0 !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .ant-table-pagination-right {\n    justify-content: center !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .ant-picker-panels {\n    flex-direction: column !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .ant-tabs-extra-content {\n    width: 50%;\n  }\n}\n\n@media (max-width: 768px) {\n  .ant-form-item-control-input-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .ant-table-cell-fix-left {\n    width: 100px !important;\n  }\n}\n\n@media (max-width: 768px) {\n  h1{\n    font-size: 18px !important;\n  }\n  th,td{\n    font-size: 12px !important;\n  }\n  .sidebarItems{\n    font-size: 12px !important;\n  }\n}",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
